// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo__ALgC-","active":"header_active__1fd0N","profileDetails":"header_profileDetails__IWf1o","profileModal":"header_profileModal__111kN"};